export const ROLES = {
  STAFF: "User",
  LAWYER: "Lawyer",
  REVIEWER: "Reviewer",
  ADMIN: "Admin",
};

export const validatePermissions = (current, allowed, type) => {
  console.log("Current", { current, allowedType: typeof allowed, allowed });

  if (current === null) {
    return false;
  }

  if (typeof allowed !== "object") {
    return false;
  }

  if (allowed.length === 0) {
    return true;
  }

  if (type === "user") {
    return allowed.includes(current[0]);
  }

  if (type === "organization") {
    return allowed.includes(current[1]);
  }
};
